import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";


import { history } from "utils";
import { NftDetailsPublic } from "views/listings/nftDetailsPublic";

const Main = () => {
    return (
        <>
            <Router history={history}>
                <Switch>
                    <Route path="/organisation/:username" render={(props) => <NftDetailsPublic {...props} />} />
                    <Redirect from="*" to="/" />
                </Switch>
            </Router>
        </>
    );
};

export default Main;
